import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import _path from 'ramda/src/path';
import CommentsView from './CommentsView';
import CommentAuthor from './CommentAuthor';
import { MessageProvider } from '../Message';

const CommentsContainer = ({ data, setState, lazy }) => {
    const [inputValue, setInputValue] = useState('');
    const textareaRef = useRef(null);

    if (!_path(['RESAAS', 'User2', 'UserId'], window)) {
        return null;
    }

    return (
        <React.Fragment>
            <CommentsView
                data={data}
                setState={setState}
                lazy={lazy}
                inputValue={inputValue}
                setInputValue={setInputValue}
                textareaRef={textareaRef}
            />
            <MessageProvider>
                <CommentAuthor
                    data={data}
                    setState={setState}
                    lazy={lazy}
                    inputValue={inputValue}
                    setInputValue={setInputValue}
                    textareaRef={textareaRef}
                />
            </MessageProvider>
        </React.Fragment>
    );
};

CommentsContainer.propTypes = {
    data: PropTypes.object.isRequired,
    lazy: PropTypes.bool,
    setState: PropTypes.func.isRequired
};

export default CommentsContainer;
